import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const SuccessWrapper = styled.div`
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
`;

export const SuccessMessage = styled.div.attrs({ role: 'alert' })`
    display: inline-block;
    padding-top: ${getPurpurSpacing('200')};
    padding-bottom: ${getPurpurSpacing('200')};
    padding-left: ${getPurpurSpacing('400')};
    padding-right: ${getPurpurSpacing('400')};
    background-color: #0c6;
    color: #fff;
    margin-bottom: ${getPurpurSpacing('300')};
`;
